export const colors = {
	$black: '#252a34',
	$lblack: '#384150',
	$lgray: '#f9f8fd',
	$blue: '#46d1fb',
	$purple: '#8ea3fe',
}

//预警选择配置
export const warns = [{
	warning: 7,
	value: '一周内'
}, {
	warning: 30,
	value: '30天内'
}, {
	warning: 90,
	value: '90天内'
}, {
	warning: -1,
	value: '已过期'
}]


// WEBPACK FOOTER //
// ./src/js/param.js